(function () {

    'use strict';

    function definition(enums, App, Backbone, Marionette, $, _) {

        enums.oauthTokenStates = {
            BROKEN_CONNECTION: 1,
            GOOD_CONNECTION: 2,
            INSUFFICIENT_PERMISSION: 3,
            PRESENCE_NOT_MAPPED: 4,
            REMOVED_PRIVATE_ACCESS: 5,
            UNKNOWN: 6
        };
    }

    if (typeof window === 'undefined') {
        const App = {
            enums: {}
        };
        definition(App.enums, App);
        module.exports = App.enums.oauthTokenStates;
    } else {
        RivalIQ.module('enums', definition);
    }

}());
